<template>
  <div class="warpper">
  <div class="salesCountdownBar-span">
                  <span class="salesCountdownBar-span-text">{{ day }}</span>
                  <!-- <span class="salesCountdownBar-span-text">{{cruise.deadlineSaleCountdown}}</span> -->
                </div>
                <div class="salesCountdownBar-div">天</div>
                <div class="salesCountdownBar-span">
                  <span class="salesCountdownBar-span-text">
    {{ hours }}:{{ minutes }}:{{ secs }}
  </span>
                </div>
  </div>
</template>

<script>
export default {
  name: 'uCountDown',
  props: {
    timestamp: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      day:0,
      timer: null,
      hours: 0,
      minutes: 0,
      secs: 0,
      time: 0,
    }
  },

  watch: {
    timestamp: {
      handler(val) {
        console.log('timestamp', val)
        this.time = val > 86400 ? val % 86400 : val
        if (this.timer) {
          clearInterval(this.timer)
          this.timer = null
        }
        this.timer = setInterval(() => {
          this.convertSecondsToTime(this.time)
        }, 1000)
      },
      immediate: true
    }

  },

  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  },


  methods: {
    convertSecondsToTime(seconds) {
      const hours = Math.floor(seconds / 3600).toString().padStart(2, '0'); // 使用padStart确保是两位数
      const minutes = Math.floor((seconds % 3600) / 60).toString().padStart(2, '0'); // 使用padStart确保是两位数
      const secs = (seconds % 60).toString().padStart(2, '0'); // 使用padStart确保是两位数
      this.hours = hours
      this.minutes = minutes
      this.secs = secs
      this.day = parseInt(this.timestamp / 86400)
      this.time = this.time == 0 ? 0 : this.time - 1
      if(parseInt(this.timestamp / 86400) > 0 && this.time <= 0){
        window.location.reload()
      }
    }
  },

}
</script>

<style lang="less" scoped>

.warpper{
  display: flex;
  align-items: center;
  gap: 0 2px;
}
</style>